import { getFilteredUserConfiguration } from 'mini-settings/lib/selectors/getFilteredUserConfiguration';
import { DayOfWeek } from 'fabric-calendar';

/**
 * Gets the user preferred week start day
 */
export const getFirstDayOfWeek = (): DayOfWeek =>
    getFilteredUserConfiguration()?.UserOptions?.WeekStartDay ?? 0;
